import React, { useState, useEffect, useRef, Fragment } from "react";
import { Nav, Icon } from "@alifd/next";
import { isEmpty, isEqual } from "lodash";
import classnames from "classnames";
import Stickyfill from "stickyfilljs";
import "./index.less";

const { Item, SubNav } = Nav;

const hideNav = (groups) => {
  return isEmpty(groups) || groups.length <= 1;
};

function NavBar(props) {
  const { groups = [], triggerScroll } = props;
  const [selectedKeys, setSelectedKeys] = useState([]);
  const stickyfEl = useRef(null);

  const onSelectHandler = (keys, item, extra) => {
    setSelectedKeys(keys);
    triggerScroll(extra.key);
  };

  const onClickHandler = (key) => {
    setSelectedKeys([key]);
    triggerScroll(key);
  };

  useEffect(() => {
    if (stickyfEl && stickyfEl.current) {
      Stickyfill.addOne(stickyfEl.current);
    }
  });

  useEffect(() => {
    if (!isEmpty(groups)) {
      const keys = groups
        .filter((group) => group.isActive === true)
        .map((group) => group.fieldId);
      if (!isEqual(selectedKeys, keys)) {
        setSelectedKeys(keys);
      }
    }
  }, [groups, selectedKeys]);

  return hideNav(groups) ? null : (
    <div className="gov-form-nav" ref={stickyfEl} id="govFormNav">
      <Nav
        direction="hoz"
        type="normal"
        onSelect={onSelectHandler}
        selectedKeys={selectedKeys}
      >
        {groups
          .filter((group) => !group.hideOnNav)
          .map((group) => {
            if (isEmpty(group.subNav)) {
              return (
                <Item key={group.fieldId}>
                  {group.hasError ? (
                    <Icon type="warning" className="warning-icon" />
                  ) : null}
                  {group.name}
                </Item>
              );
            } else {
              return (
                <SubNav
                  className={classnames({
                    "next-selected": selectedKeys.includes(group.fieldId),
                  })}
                  key={group.fieldId}
                  onClick={() => onClickHandler(group.fieldId)}
                  label={
                    <Fragment>
                      {group.hasError ? (
                        <Icon type="warning" className="warning-icon" />
                      ) : null}
                      {group.name}
                    </Fragment>
                  }
                >
                  {group.subNav.map((item) => (
                    <Item key={item.fieldId}>{item.name}</Item>
                  ))}
                </SubNav>
              );
            }
          })}
      </Nav>
    </div>
  );
}
export default NavBar;
